import React, { useState, useEffect } from 'react';
import Modal from 'react-modal';
import ViewBooking from './ViewBooking';
import BookingServices from '../../services/BookingServices';

function ViewUser({ user, closeModal }) {
  // Move hooks to the top level
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedUser, setSelectedUser] = useState(null);
  const [booking, setBooking] = useState(null);
  const [activeIndex, setActiveIndex] = useState(null);

  const handleViewDetails = (book) => {
    setSelectedUser(book);
    setIsModalOpen(true);
  };

  const toggleActionMenu = (index) => {
    setActiveIndex(index === activeIndex ? null : index);
  };

  const closeUserModal = () => {
    setIsModalOpen(false);
    setSelectedUser(null);
  };

  function formatDateTime(isoString) {
    const date = new Date(isoString);
    const formattedDate = date.toLocaleDateString();
    const formattedTime = date.toLocaleTimeString();
    return { date: formattedDate, time: formattedTime };
  }

  const formatDate = (dateString) => {
    const date = new Date(dateString);

    if (isNaN(date.getTime())) {
      return 'N/A';
    }

    const day = date.getDate().toString().padStart(2, '0');
    const month = (date.getMonth() + 1).toString().padStart(2, '0');
    const year = date.getFullYear().toString();

    return `${day}-${month}-${year}`;
  };



  useEffect(() => {
    if (!user) return;
    const fetchBooking = async () => {
      try {
        const response = await BookingServices.getMyBookingById(user._id);
        setBooking(response.data);
        console.log(response.data)
      } catch (error) {
        console.error('Error fetching booking:', error);
      }
    };
    fetchBooking();
  }, [user]);

  if (!user) return null;

  return (
    <div className="modal fade viewbox edit-box show d-block" tabIndex={-1} aria-labelledby="userModal" aria-hidden="true">
      <div className="modal-dialog modal-dialog-centered">
        <div className="modal-content">
          <div className="modal-header">
            <h5 className="modal-title">User Details</h5>
            <button type="button" className="btn-close" onClick={closeModal} aria-label="Close"></button>
          </div>
          <div className="modal-body">
            <div className="container">
              {/* User Info Section */}
              <div className="container-box user-manager" style={{ padding: '10px', marginTop: '15px' }}>
                <div className="view-profile-outer d-flex justify-content-center">
                  {/* <img src="img/profile-1.svg" alt="Profile" /> */}
                  <img src={user?.image ? `${process.env.REACT_APP_URL}${user.image}` : 'img/profile-1.svg'} alt="" style={{ height: '100px', width: '100px', objectFit: 'contain' }} />
                </div>
                <h3 className="faqs-1" style={{ marginTop: '10px', textAlign: 'center' }}>
                  {user?.name || 'N/A'}
                </h3>
              </div>

              <div className="container-box user-manager" style={{ padding: '10px', marginTop: '15px' }}>
                <ul className="user-details list-unstyled d-flex justify-content-between">
                  <li>
                    <span>Email</span>
                    <p>{user?.email || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Phone</span>
                    <p>{user?.mobileNo || 'N/A'}</p>
                  </li>
                  <li>
                    <span>City</span>
                    <p>{user?.city || 'N/A'}</p>
                  </li>
                </ul>
                <ul className="user-details list-unstyled d-flex justify-content-between">
                  <li>
                    <span>Date of Birth</span>
                    <p>{formatDate(user?.dateofbirth) || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Reg. date</span>
                    <p>{formatDate(user?.createdAt) || 'N/A'}</p>
                  </li>
                  <li>
                    <span>Login Type</span>
                    <p>{user?.loginType || 'Mobile Number'}</p>
                  </li>
                </ul>
              </div>

              {/* Booking History Section */}
              <div className="booking-detail container-box user-manager" style={{ overflowX: "auto", whiteSpace: "nowrap", marginTop: "20px" }}>
                <h4>Booking History</h4>
                <table className="table table-striped" style={{ border: '1px solid #FFFFFF', borderRadius: '10px' }}>
                  <thead style={{ backgroundColor: '#D9D9D9' }}>
                    <tr>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Booking ID</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Cottage Name</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Check-in</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Check-Out</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Status</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Amount</th>
                      <th style={{ color: '#fff', backgroundColor: '#8C8FA7' }}>Action</th>
                    </tr>
                  </thead>
                  <tbody>
                    {booking && booking.length > 0 ? (
                      booking.map((book, index) => (
                        <tr key={index} style={{ backgroundColor: '#F9FAFF' }}>
                          <td className='bookingId'>#{book.bookingId || 'N/A'}</td>
                          <td>{book?.cottage?.name || 'N/A'}</td>
                          <td>{formatDate(book?.checkInDate) || 'N/A'}</td>
                          <td>{formatDate(book?.checkOutDate) || 'N/A'}</td>
                          <td>
                            <button
                              className="reset-button"
                              style={{
                                backgroundColor:
                                  book.status === 'Pending'
                                    ? '#F9B842'
                                    : book.status === 'Completed'
                                      ? '#28a745'
                                      : '#dc3545',
                              }}
                            >
                              {book?.status || 'N/A'}
                            </button>
                          </td>
                          <td>₹{book?.totalAmount || 'N/A'}</td>
                          <td className="d-flex" style={{ gap: '20px' }}>
                            <button
                              className="edit trans-btn"
                              onClick={() => handleViewDetails(book)}
                            >
                              <img src="img/view-btn.svg" alt="View" />
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td colSpan="7" style={{ textAlign: 'center' }}>
                          No Booking Data Available
                        </td>
                      </tr>
                    )}
                  </tbody>
                </table>
              </div>

            </div>
          </div>
          <div className="modal-footer d-flex">
            <button type="button" className="site-btn-green" style={{ marginBlock: '15px' }} onClick={closeModal}>
              CLOSE
            </button>
          </div>
        </div>
      </div>
      <Modal
        isOpen={isModalOpen}
        onRequestClose={closeUserModal}
        contentLabel="User Details"
        className="modal-content"
        overlayClassName="modal-overlay"
      >
        <ViewBooking book={selectedUser} closeModal={closeUserModal} />
      </Modal>
    </div>
  );
}

export default ViewUser;
